module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sharePane', _vm.enableLinks, _vm.mode]
  }, [_c('amp-social-share', {
    staticClass: "facebook",
    attrs: {
      "type": "facebook",
      "data-param-url": _vm.facebookUrl,
      "data-param-app_id": _vm.facebookAppID
    }
  }, [_c('svg-facebook-icon', {
    staticClass: "icon--facebook"
  })], 1), _c('amp-social-share', {
    staticClass: "facebook",
    attrs: {
      "type": "twitter",
      "data-param-url": _vm.twitterUrl,
      "data-param-text": _vm.shareTitle
    }
  }, [_c('svg-twitter-icon', {
    staticClass: "icon--twitter"
  })], 1), _c('amp-social-share', {
    staticClass: "whatsapp",
    attrs: {
      "type": "whatsapp",
      "data-param-text": _vm.shareTitle
    }
  }, [_c('svg-whatsapp-icon', {
    staticClass: "icon--whatsapp"
  })], 1), _c('amp-social-share', {
    attrs: {
      "type": "facebookmessenger",
      "data-share-endpoint": _vm.facabookMessengerUrl
    }
  }, [_c('svg-facebook-messenger-icon', {
    staticClass: "icon--facebook-messenger"
  })], 1), _c('amp-social-share', {
    staticClass: "email",
    attrs: {
      "type": "email",
      "data-param-url": "emailUrl"
    }
  }, [_c('svg-email-icon', {
    staticClass: "icon--email"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f6d48d4","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article/amp/AmpSharePane.vue
// module id = 1763
// module chunks = 20